const approvalCuctomerChangesColumns = {
  requestedAt: {
    key: 'requestedAt',
    label: 'requestedAt',
    type: 'datetime',
    sortable: 'custom',
    minWidth: 150,
  },
  id: {
    key: 'sample.labSampleCode',
    label: 'sampleId',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  productName: {
    key: 'sample.productName',
    label: 'productName',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  customerName: {
    key: 'sample.customer.name',
    label: 'customerName',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  labsampleCodes: {
    key: 'sample.labsamples',
    label: 'labSampleIds',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  customerProductName: {
    key: 'sample.customerProductName',
    label: 'customerSampleCode',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  lot: {
    key: 'sample.lot',
    label: 'lot',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  date: {
    key: 'sample.date',
    label: 'lotDate',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  sector: {
    key: 'sample.sector',
    label: 'sector',
    type: 'enum',
    enum: 'sectors',
    sortable: false,
    minWidth: 130,
  },
  packagesNumber: {
    key: 'sample.packagesNumber',
    label: 'packagesNumber',
    type: 'text',
    sortable: false,
    minWidth: 90,
  },
  notes: {
    key: 'sample.notes',
    label: 'customerNotes',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  finalCustomer: {
    key: 'sample.finalCustomer',
    label: 'finalCustomer',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  sampleDescription: {
    key: 'sample.sampleDescription',
    label: 'sampleDescription',
    type: 'enum',
    enum: 'sampleDescriptions',
    sortable: false,
    minWidth: 200,
  },
  comments: {
    key: 'sample.comments',
    label: 'sampleInstructions',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  costCenter: {
    key: 'sample.costCenter',
    label: 'costCenter',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 200,
    buttons: [
      {
        name: 'viewDiff',
        icon: 'fas fa-exchange',
        permissions: ['receivedSamplesManage'],
      },
      {
        name: 'accept',
        icon: 'fas fa-check-square',
        permissions: ['receivedSamplesManage'],
      },
      {
        name: 'refuse',
        icon: 'fas fa-do-not-enter',
        permissions: ['receivedSamplesManage'],
      },
    ],
  },
};

export default approvalCuctomerChangesColumns;
